import {isFeatureEnabled} from '@github-ui/feature-flags'
import useColorModes from '@github-ui/react-core/use-color-modes'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {BrandPageContent} from '../../brand/components/BrandPage'

import {HomeView} from './components/pageViews/HomeView/HomeView'
import {toPayload} from './payload'
import {homePage} from './utils/content'
import {parseContentfulData} from './utils/parse-contentful'

export interface HomeProps {}

export const defaultProps: Partial<HomeProps> = {}

// eslint-disable-next-line no-empty-pattern
export function HomePage({}: HomeProps) {
  const {colorMode} = useColorModes()
  const pageColorMode =
    !isFeatureEnabled('site_homepage_refresh_2026_auto_theme_support') || colorMode === 'day'
      ? 'light'
      : colorMode === 'night'
        ? 'dark'
        : 'auto'
  const payload = toPayload(useRoutePayload<unknown>())

  return (
    <BrandPageContent definition={homePage} colorMode={pageColorMode}>
      {content => (
        <HomeView
          copy={parseContentfulData(content)}
          runtime={{
            isLoggedIn: !!payload.userLoggedIn,
            isOrgAdmin: !!payload.orgAdminType,
            recentEvents: (payload.recentEvents ?? []).map(data => ({data})),
            featuredRepositories: payload.featuredRepositories ?? [],
          }}
        />
      )}
    </BrandPageContent>
  )
}
